<div
	class="bg-surface-100 dark:bg-surface-900 py-20 px-6 md:px-12 lg:px-20 flex flex-col gap-8 justify-center items-center relative">
	<div class="flex flex-col gap-2 items-center max-w-3xl mx-auto">
		<app-headline-large
			[title]="content.title"
			class="text-center!"></app-headline-large>
		<app-body-large [description]="content.description"></app-body-large>
	</div>
	@if (content.copy.length > 0){
	<div class="mx-auto">
		<!-- mobile -->
		<div class="xl:hidden flex flex-col gap-12">
			@for (item of content.copy; track item.title; let index = $index) {
			<div
				pAnimateOnScroll
				enterClass="animate-enter fade-in-10 slide-in-from-b-20 animate-duration-1000"
				class="grid grid-cols-1 sm:grid-cols-[42px_1fr] gap-4">
				<div class="hidden sm:flex flex-col items-center">
					<div
						class="w-12 h-12 border border-surface-200 dark:border-surface-700 flex items-center justify-center px-1 py-2 bg-white dark:bg-surface-800">
						<span class="text-surface-900 dark:text-surface-0 font-medium text-xl leading-tight">{{ index + 1 }}</span>
					</div>
					<div class="w-px bg-surface-200 dark:bg-surface-700 flex-1"></div>
				</div>
				<div class="flex w-full flex-col gap-4">
					<div
						class="border-10 border-white w-full h-52 bg-surface-50 dark:bg-surface-800 overflow-hidden flex justify-center items-start shadow relative">
						<img
							loading="lazy"
							[src]="item.image.src"
							[alt]="item.image.alt"
							class="object-cover w-full h-full" />
					</div>
					<div class="flex flex-col gap-4">
						<div class="flex flex-col gap-2">
							<h4 class="text-primary-500 dark:text-surface-0 font-bold text-base leading-tight">
								{{ 'STEP ' }}{{ index + 1 }}
							</h4>
							<h3 class="text-surface-900 dark:text-surface-400 leading-normal font-semibold text-lg">
								{{ item.title }}
							</h3>
							<app-body-large [description]="item.description"></app-body-large>
						</div>
					</div>
				</div>
			</div>
			}
		</div>

		<!-- desktop -->
		<div class="hidden xl:flex flex-col gap-12">
			@for (item of content.copy; track item.title; let index = $index) {
			<div
				pAnimateOnScroll
				enterClass="animate-enter fade-in-10 slide-in-from-b-20 animate-duration-1000"
				class="flex gap-12 items-center">
				<div class="w-127">
					<div
						class="border-10 border-white h-52 bg-surface-50 dark:bg-surface-800 overflow-hidden flex justify-center items-start shadow relative">
						<img
							loading="lazy"
							[src]="item.image.src"
							[alt]="item.image.alt"
							class="object-cover w-full h-full" />
					</div>
				</div>
				<div class="flex flex-col items-center">
					<div
						class="w-12 h-12 border border-surface-200 dark:border-surface-700 flex items-center justify-center px-1 py-2 bg-white dark:bg-surface-800">
						<span class="text-surface-900 dark:text-surface-0 font-medium text-xl leading-tight">{{ index + 1 }}</span>
					</div>
					<div class="w-px bg-surface-200 dark:bg-surface-700 h-[200px]"></div>
				</div>
				<div class="w-127">
					<div class="flex flex-col gap-4">
						<div class="flex flex-col gap-2">
							<h4 class="text-primary-500 dark:text-surface-0 font-bold text-base leading-tight">
								{{ 'STEP ' }}{{ index + 1 }}
							</h4>
							<h3 class="text-surface-900 dark:text-surface-400 leading-normal font-semibold text-lg">
								{{ item.title }}
							</h3>
						</div>
						<div class="h-px bg-surface-200 dark:bg-surface-700 w-full"></div>
						<div class="flex flex-col gap-2">
							<app-body-large [description]="item.description"></app-body-large>
						</div>
					</div>
				</div>
			</div>
			}
		</div>
	</div>
	} @if (content.link){
	<app-link
		[type]="content.link.type"
		[routerLink]="content.link.path"
		[label]="content.link.title"
		bgColor="light"></app-link>
	}
</div>
